export const LINKS = {
  EDZIENNIK: process.env.REACT_APP_EDZIENNIK,
  POCZTA: process.env.REACT_APP_POCZTA,
  GITHUB: process.env.REACT_APP_GITHUB
};